import React from 'react';
import FeatureUnavailable from '../components/FeatureUnavailable';

/**
 * StockBot AI Page
 * 
 * This service is currently in development.
 * Display a "Coming Soon" page until the service is ready.
 */
const StockBot: React.FC = () => {
  return (
    <FeatureUnavailable
      title="Coming Soon"
      subtitle="StockBot AI"
      description="The first AI built fully by FairCorp, designed to guide new investors with real-time suggestions on stocks to buy, sell, or hold. Get intelligent investment recommendations powered by advanced market analysis."
      featureType="service"
      serviceName="StockBot AI"
      logoSrc="/mono-stockbot-ai.png"
      showBackButton={true}
      backPath="/work"
      showHomeLink={true}
      showContactOption={true}
    />
  );
};

export default StockBot;
